<template>
  <div class="alarm-info">
    <el-row type="flex"
            justify="space-between">
      <el-col>
        <h3 class="row-title-left">{{ $t('alarmHistory.alarmInfo') }}</h3>
      </el-col>
      <el-col>
        <h3 class="row-title-right"
            @click="showMoreAlarmInfo">{{ $t('alarmHistory.more') }}</h3>
      </el-col>
    </el-row>
    <el-row class="table-row">
      <el-table :data="alarmData"
                v-loading="loadingData"
                style="width: 100%">
        <el-table-column prop="noticeTime"
                         :formatter="maybeEmpty"
                         :label="$t('alarmHistory.alarmTime')">
        </el-table-column>
        <el-table-column prop="resourceTypeName"
                         :formatter="maybeEmpty"
                         :label="$t('alarmHistory.resourceType')">
        </el-table-column>
        <el-table-column prop="resourceName"
                         :formatter="maybeEmpty"
                         :label="$t('alarmHistory.resourceName')">
        </el-table-column>
        <el-table-column :label="$t('alarmHistory.ipAndPort')"
                         min-width="120px">
          <template slot-scope="scope">
            {{scope.row.managementIp}} <br /> {{scope.row.ifName}}
          </template>
        </el-table-column>
        <el-table-column prop="condition"
                         :formatter="maybeEmpty"
                         min-width="220px"
                         :label="$t('alarmHistory.alarmCondition')">
        </el-table-column>
        <el-table-column prop="value"
                         :formatter="maybeEmpty"
                         :label="$t('alarmHistory.alarmValue')">
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'alarmInfo',
  props: {
    alarmList: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    idcId: {
      type: [String, Number],
      required: true,
      default: null
    }
  },
  computed: {
    alarmData () {
      return cloneDeep(this.alarmList);
    },
    loadingData () {
      return this.loading;
    }
  },
  methods: {
    showMoreAlarmInfo () {
      this.$router.push({
        path: '/alarmhistory/list',
        query: { idcId: this.idcId }
      });
    },
    maybeEmpty (row, column) {
      const arr = row[column.property];
      const sign = '--';
      return arr || sign;
    }
  },
};
</script>
<style lang="scss" scoped>
.alarm-info {
  .row-title-left {
    padding-left: 11px;
  }
  .row-title-right {
    padding-right: 11px;
    text-align: right;
    color: #2c68ff;
    cursor: pointer;
    &:hover{
      color: #2aafff;
    }
  }
  .row-title-right,
  .row-title-left {
    font-size: 14px;
  }
  .table-row {
    padding: 11px 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourceOverview/sub/AlarmInfo.vue